var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preViews"},[_c('page-none',{attrs:{"resultList":_vm.detailList,"swiperList":_vm.swiperList,"pages":_vm.pages},on:{"clickPagination":_vm.clickPagination}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }